import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-overview-card',
  imports: [CommonModule, TranslateModule],
  templateUrl: './overview-card.component.html',
  styleUrl: './overview-card.component.css'
})
export class OverviewCardComponent {



  title = input.required<string>();
  number = input<number>();
  iconClass = input.required<string>();

  description = input<string>();
  subDescription = input<string>();
  subDescriptionColor = input<string>();

  showCurrency = input<boolean>(false);

  iconBgColor = input.required<string>();
  iconColor = input.required<string>();

  loading = input<boolean>(false);

}
